export const toInstagramHandle = (url?: string | null): string => {
  if (!url?.trim()) return '-';
  const trimmed = url.trim();
  if (/^@[A-Za-z0-9._]+$/.test(trimmed)) return trimmed;
  const matched = trimmed.match(/instagram\.com\/([A-Za-z0-9._]+)/i);
  return matched ? `@${matched[1]}` : '-';
};
